import { useAtom } from "jotai";
import { useRef } from "react";

import { intersectingNumberAtom } from "@/businessLogics/_common/util-browser/useIntersection";
import { useScrollDirection } from "@/businessLogics/_common/logging/useScrollDirection";
import LandingPageSolutionMolecule from "@/components/molecules/LandingPageMolecules/LandingPageSolutionMolecule/LandingPageSolutionMolecule";
import { SolutionData } from "@/models/landing/solution/solution.model";

import * as S from "./LandingPageSolutionOrganism.style";

export let solutionRef;
const LandingPageSolutionOrganism = ({
  title,
  landingSolutionData,
}: {
  title: JSX.Element;
  landingSolutionData: SolutionData[];
}) => {
  solutionRef = useRef();
  const [intersectingNumber] = useAtom(intersectingNumberAtom);
  const scrollUp = useScrollDirection();

  return (
    <S.Wrapper ref={solutionRef}>
      <S.Fix id="fix" scrollUp={scrollUp}>
        <S.Text>
          <S.Title>{title}</S.Title>
        </S.Text>
        <S.Nav>
          <S.Divider />
          <S.Step intersecting={+intersectingNumber === 1}>
            <S.Number intersecting={+intersectingNumber === 1}>1</S.Number>
            기획
          </S.Step>
          <S.Step intersecting={+intersectingNumber === 2}>
            <S.Number intersecting={+intersectingNumber === 2}>2</S.Number>
            개발
          </S.Step>
          <S.Step intersecting={+intersectingNumber === 3}>
            <S.Number intersecting={+intersectingNumber === 3}>3</S.Number>
            마케팅
          </S.Step>
          <S.Step intersecting={+intersectingNumber === 4}>
            <S.Number intersecting={+intersectingNumber === 4}>4</S.Number>
            개선
          </S.Step>
          <S.Step intersecting={+intersectingNumber === 5}>
            <S.Number intersecting={+intersectingNumber === 5}>5</S.Number>
            회고
          </S.Step>
        </S.Nav>
      </S.Fix>
      <S.MobileNav scrollUp={scrollUp}>
        <S.MobileDivider />
        <S.Step intersecting={+intersectingNumber === 1}>
          <S.Number intersecting={+intersectingNumber === 1}>1</S.Number>
          기획
        </S.Step>
        <S.Step intersecting={+intersectingNumber === 2}>
          <S.Number intersecting={+intersectingNumber === 2}>2</S.Number>
          개발
        </S.Step>
        <S.Step intersecting={+intersectingNumber === 3}>
          <S.Number intersecting={+intersectingNumber === 3}>3</S.Number>
          마케팅
        </S.Step>
        <S.Step intersecting={+intersectingNumber === 4}>
          <S.Number intersecting={+intersectingNumber === 4}>4</S.Number>
          개선
        </S.Step>
        <S.Step intersecting={+intersectingNumber === 5}>
          <S.Number intersecting={+intersectingNumber === 5}>5</S.Number>
          회고
        </S.Step>
      </S.MobileNav>
      <LandingPageSolutionMolecule landingSolutionData={landingSolutionData} />
    </S.Wrapper>
  );
};

export default LandingPageSolutionOrganism;
